import * as SDK from '@replai-platform/sdk';
import { Filters } from '../../utils/enums';

export const supportedFilters = (accountTypes: SDK.AccountTypes[]) => [
  ...(accountTypes?.includes(SDK.AccountTypes.SOCIALS) ? [] : [Filters.Spend, Filters.Campaigns]),
  Filters.Countries,
];
